import { Flex, Icon, type IconName, Text } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { containerStyle, variantStyles } from "./MessageBanner.css";

export type MessageBannerVariant = "info" | "error";

export type MessageBannerProps = {
  icon: IconName;
  body: string;
  variant?: MessageBannerVariant;
  className?: string;
};

export const MessageBanner = ({
  icon,
  body,
  variant = "info",
  className,
}: MessageBannerProps) => (
  <Flex
    className={mergeClasses(containerStyle, variantStyles[variant], className)}
    gap="s"
    align="center"
  >
    <Icon
      icon={icon}
      size="s"
      animation={icon === "loading" ? "rotation" : undefined}
    />
    <Text grow>{body}</Text>
  </Flex>
);
